define('mapbox',['app'],function(app){
    //
    var accessToken,
        geocoder;
    //
    app.once('hooksStarted',function(){
        accessToken = app.c('_MAPBOX_ACCESS_TOKEN_');
    });

    var Mapbox = {
        geocode:function(query,callback){
            if(!window.L){
                // si le SDK mapbox
                return require(['mapboxJS'],function(){
                    Mapbox.geocode(query,callback);
                });
            }
            if(!geocoder){
                geocoder = L.mapbox.geocoder('mapbox.places',{accessToken:accessToken});
            }
            geocoder.query(query,callback);
        }
    };

    return Mapbox;
});
